import image_by_key from 'components/ButtonWithIcon/data/button_with_icon_images'
import { keys, omit } from 'lodash'
import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css, keyframes } from 'styled-components'
import { darken } from 'polished'
import widgetContextConnector from 'pages/Widget/_context/WidgetContext/widgetContextConnector'


const clearProps = (props) => {
  return omit(props, keys(image_by_key))
}
const wait_animation = keyframes`
0% {
border-color: #fffa2f;
border-style: solid;
}
50% {
border-color: #914b06;
border-style: dashed;
}
100% {
border-color: #fffa2f;
border-style: solid;
}
`
const _ButtonStyles = styled(
  ({
     css,
     stretch,
     without_border,
     is_waiting,

     icon_size,
     icon_url,

     light,
     dotted,
     link,
     text,
     primary,
     danger,
     success,
     info,
     accent,

     submit,
     reset,
     type,
     ref,
     ...rest
   }
  ) => rest.href ? <a {...clearProps(rest)} ref={ref} />
                 : rest.to
                   ? <Link {...clearProps(rest)} ref={ref} />
                   : <button {...clearProps(rest)} {...{type}} ref={ref} />)`
  display: inline-block;
  vertical-align:middle;
  position: relative;
  text-align: center;
  border-radius: ${props => props.theme.borderRadius};
  color: ${props => props.w?.color || props.theme.cWhite};
  padding:${p => p.pad || '8px 20px'} ;
  cursor: pointer;
  font-size: ${p => p.fsize || '1.5rem'};
  box-shadow: -1px 0 1px 0 rgba(212, 212, 212, 0.5);
  background-color: ${props => props.w?.background_list || '#ffffff'};
  border: solid 1px ${p => p.w?.color || '#8c8c8c'};
  border: solid 1px var(--nav, ${p => p.w?.color || '#8c8c8c'});
  color: ${p => p.w?.color || '#8c8c8c'};
  color: ${p => p.w?.color || p.theme.cNav};
  line-height: inherit;
  transition: background-color .12s ease-in-out;

  @media (min-width: ${p => p.theme.mobileLargeSize}) {
    min-width: 150px;
  }

  &:hover {
      background-color: ${props => darken(0.1, props.w?.background_list || '#f1f8ff')};
    }
  &:active {
    background-color: ${props => darken(0.1, props.w?.background_list || '#e1ebf3')};
  }
  &:focus {
    outline: none;
  }


  ${p => p.stretch && css`
    width: 100%;
    display: block;
  `};


  ${props => props.primary && css`
    color: white;
    box-shadow: inset -1px 1px 0 0 rgba(255, 255, 255, 0);
    background-color: ${p => p.w?.background_list || String(p.theme.cMain)};
    border: solid 1px rgba(0, 0, 0, 0.05);
      &:hover {
        color: white;
        background: ${p => darken(0.05, p.w?.background_list || p.theme.cMain)};
      }
      &:active {
        background: ${p => darken(0.1, p.w?.background_list || p.theme.cMain)};
        color: white;
      }

  `};

  ${props => props.danger && css`
      color: ${p => p.theme.cDanger};
      border: solid 1px ${p => darken(0.05, p.w?.background_list || p.theme.cDanger)};

      &:hover {
        color: white;
        background: ${p => darken(0.05, p.w?.background_list || p.theme.cDanger)};
      }
      &:active {
        background: ${p => darken(0.01, p.w?.background_list || p.theme.cDanger)};
        color: white;
      }
  `};

  ${props => props.success && css`

      background-color: ${p => p.w?.background_list || p.theme.cSuccess};
      color: #fefefe;
      border: solid 1px ${p => darken(0.05, p.w?.background_list || p.theme.cSuccess)};

      &:hover {
        color: #ffffff;
         background-color: ${p => darken(0.05, p.w?.background_list || p.theme.cSuccess)};
      }
      &:active {
         background-color: ${p => darken(0.1, p.w?.background_list || p.theme.cSuccess)};
      }
  `};

   ${props => props.accent && css`

      background-color: ${p => p.w?.background_list || p.theme.cAccent};
      color: #fefefe;
      border: solid 1px ${p => darken(0.05, p.w?.background_list || p.theme.cAccent)};

      &:hover {
        color: #ffffff;
        background-color: ${p => darken(0.05, p.w?.background_list || p.theme.cAccent)};
      }
      &:active {
        color: #fefefe;
        background-color: ${p => darken(0.1, p.w?.background_list || p.theme.cAccent)};
      }
  `};


${props => props.info && css`

      background-color: ${p => p.w?.background_list || p.theme.cInfo};
      color: #fefefe;
      border: solid 1px ${p => darken(0.05, p.w?.background_list || p.theme.cInfo)};

      &:hover {
        color: #ffffff;
         background-color: ${p => darken(0.05, p.w?.background_list || p.theme.cInfo)};
      }
      &:active {
         background-color: ${p => darken(0.1, p.w?.background_list || p.theme.cInfo)};
      }
  `};


  ${props => props.light && css`
      background-color: transparent;
      color: gray;
      &:hover {
        background-color: #EEE;
        color: #333;
      }
  `};

  ${props => props.text && css`
      background-color: transparent;
      box-shadow: none;
      display: inline;
      border: none;
       &:hover {
        color: ${p => p.w?.color || '#333'};
        background: transparent;
      }
      &:active {
        color: ${p => p.w?.color_active || '#000'};
      }
      ${p => !p.danger && css`
      color: gray;
`};      ${p => p.danger && css`
        &:hover {
        color: ${p => darken(0.05, p.w?.color || p.theme.cDanger)};
      }
      &:active {
        color: ${p => darken(0.1, p.w?.color || p.theme.cDanger)};
      }
`};
      padding: 0;
      vertical-align: baseline;

  `};

  ${props => props.link && css`

      background-color: transparent;
      box-shadow: none;
      display: inline;
      border: none;
      color: gray;
      padding: 8px 0;
      &:hover {
        color: ${p => p.w?.color || '#333'};
        background: transparent;
      }
      &:active {
        color: ${p => p.w?.color_active || '#000'};
      }
  `};





  ${p => p.icon_url && css`
     background-color: transparent;
     background-image: url(${p.icon_url});
     background-size: contain;
     background-repeat: no-repeat;
     padding: 0;
     width: ${p.icon_size ? p.icon_size : '25px'};
     height: ${p.icon_size ? p.icon_size : '25px'};
     opacity: .9;
     &:hover {
      background-color: transparent;
      opacity: 1;
     }
     &:visited {
       opacity: .9;
     }
  `};

  ${p => p.small && css`
    padding: 4px 8px;
  `};

  ${p => p.dotted && css`
    border: none;
    border-bottom: 1px dashed;
    box-shadow: none;
    padding: 0;
    display: inline-block;
    font-size: inherit;
    line-height: inherit;
    vertical-align: inherit;
  `};

  ${p => p.link && css`
    ${p => p.theme.mixin.linkButton.color(p, 'blue')};

    border: none;
    box-shadow: none;
    padding: 0;
    display: inline;
    font-size: inherit;
    line-height: inherit;
    vertical-align: inherit;
  `};

  :disabled {
    filter: grayscale(1);
    opacity: .8;
    cursor: none;
    pointer-events: none;
  }

  ${p => p.without_border && css`
      border: none;
      box-shadow: none;
      color: ${p => p.theme.cBlack};
      border-radius: 0;
  `};

  ${p => p.is_waiting && css`
    animation: ${wait_animation} 1.08s ease infinite;
  `};

  ${p => p.theme.is_keyboard_user && css`
    &:focus {
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% + 6px);
        height: calc(100% + 5px);
        background: transparent;
        border-radius: calc(${props => props.theme.borderRadius} + 2px);
        border: solid 2px ${p => p.theme.cBlue};

      }
    }
  `};

    ${p => p.css};
`

const ForwardedButtonStyles = React.forwardRef((props, ref) => (
  <_ButtonStyles {...props} ref={ref} />
));

export default widgetContextConnector(['widgetparams:w'])(ForwardedButtonStyles);
